import { gql } from '@/__generated__';

export const GET_USER_NAME = gql(`#graphql
  query GetUserName($input: UserInput) {
    user(input: $input) {
      id
      fullName
    }
  }
`);
